import { render } from "./offline-data.vue?vue&type=template&id=1bd55f5a"
import script from "./offline-data.vue?vue&type=script&lang=ts"
export * from "./offline-data.vue?vue&type=script&lang=ts"
script.render = render

export default script